import React from "react";
import { observer } from "mobx-react-lite";
import { CourtCoverageDescBox } from "./CourtCoverageDescriptionBox";
import { useMatchStatsStore } from "../../../stores/StoreContext";

type props = {};

export const CourtCoverageDescription: React.FC<props> = observer(() => {
  const matchStatsStore = useMatchStatsStore();

  return (
    <div style={styles.container}>
      <CourtCoverageDescBox
        title="Distance run"
        subtitle="meters"
        measurement={Math.floor(
          matchStatsStore.playerStatsMap.get(
            parseInt(matchStatsStore.clutchMatchCurrentPlayer.userId ?? "0")
          )?.distanceRunMeters ?? 0
        ).toString()}
      />
      <CourtCoverageDescBox
        title="Number of pair shots"
        measurement={matchStatsStore.teamStatsMap
          .get(matchStatsStore.clutchMatchCurrentPlayer.teamId ?? 0)
          ?.numberOfShots.toString()}
      />
    </div>
  );
});

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    marginTop: 15,
    marginBottom: 20,
    display: "flex",
    gap: 10,
  },
};
